import React from "react";
import { component_tool } from "@/tool";
const { WizButton, WizDivider, WizDataTable } = component_tool;

export default (self, handleDelete, handleChangeStutas) => {
  return [
    {
      title: "考试模版名称",
      dataIndex: "templateName",
      editable: true,
      width: "20%",
      className: "editable-table-column",
    },
    {
      title: (
        <React.Fragment>
          岗位对象
          <span style={{ color: "rgba(153, 153, 153, 1)" }}>
            （需符合模版已设置的可见对象范围）
          </span>
        </React.Fragment>
      ),
      dataIndex: "positionNames",
      editable: true,
      className: "editable-table-column",
    },
    {
      title: "状态",
      dataIndex: "statusName",
      width: "10%",
      // dict: [
      //   { code: 1, codeName: '有效' },
      //   { code: 0, codeName: '无效' }
      // ]
    },
    {
      title: "操作",
      dataIndex: "operation",
      width: "120px",
      render: (text, record) =>
        self.state.dataSource.length >= 1 ? (
          <WizDataTable.Oper>
             <a onClick={()=>handleChangeStutas(record.key,record.status===0?1:0)}>{record.status?'禁用':'启用'}</a>
             <WizDivider type="vertical" />
             <a onClick={()=>handleDelete(record.key)}>删除</a>

           </WizDataTable.Oper>
        ) : null,
    }
  ];
}
